export const PC_PAGE_CONFIG = {
  "title": "Daily",
  "titleCN": "运营总况日报",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/daily",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/overview/daily",
      "path": "/overview/daily",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "204401",
        "pageName": "overviewPcConsoleDaily",
        "extInfo": "overviewPcConsoleDaily",
        "pagePath": "/overview/daily"
      },
      "filters": [
        {
          "name": "PcConsoleDailyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/daily",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "KeyMetricTitle",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                      "metric": "units",
                      "switchSlot": {
                        "name": "SwitchStateWrap",
                        "style": {},
                        "props": {
                          "componentMap": {
                            "checked": [
                              {
                                "name": "PlatformMetricsCo",
                                "className": "margin-t-20",
                                "type": "view",
                                "style": {},
                                "props": {
                                  "config": {
                                    "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                    "metricsList": [
                                      "units_number",
                                      "revenue_after_chargeback"
                                    ]
                                  }
                                },
                                "children": [
                                  {
                                    "name": "CommonRow",
                                    "className": "",
                                    "type": "layout",
                                    "style": {},
                                    "props": {},
                                    "children": [
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 12
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "UnitsNumberPlatformCard",
                                            "height": 235,
                                          }
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 12
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "RevenueAfterChargebackPlatformCard",
                                            "height": 235,
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "name": "KeyMetricsCo",
                                "className": "dbd-daily-card",
                                "type": "view",
                                "style": {},
                                "props": {
                                  "config": {
                                    "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                    "haveJump": true,
                                    "mainMetricsList": [
                                      "lifetime_full_game_net_units",
                                      "lifetime_revenue_after_refund",
                                      "lifetime_refund_rate",
                                      "active_users",
                                      "new_users",
                                      "d1t1",
                                      "median_online_time",
                                      "median_session_time",
                                      "pcu"
                                    ],
                                    "metricsList": [
                                      "lifetime_full_game_net_units",
                                      "lifetime_revenue_after_refund",
                                      "lifetime_refund_rate",
                                      "active_users",
                                      "new_users",
                                      "pcu",
                                      "d1t1",
                                      "d2t2",
                                      "d7t7",
                                      "median_online_time",
                                      "aot_hour",
                                      "above_2hr_users",
                                      "median_session_time",
                                      "avg_session_time",
                                      "avg_session_cnt",
                                    ]
                                  }
                                },
                                "children": [
                                  {
                                    "name": "CommonRow",
                                    "className": "",
                                    "type": "layout",
                                    "style": {},
                                    "props": {},
                                    "children": [
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 12
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "LifetimeFullGameNetUnitsMetricCard",
                                            "height": 160,
                                          },
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 12
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "LifetimeRevenueAfterRefundMetricCard",
                                            "height": 160,
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "name": "CommonRow",
                                    "className": "",
                                    "type": "layout",
                                    "style": {},
                                    "props": {},
                                    "children": [
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 6
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "LifetimeRefundRateMetricCard",
                                            "height": 160,
                                            "config": {
                                              "props": {
                                                "config": {
                                                  "componentMetrics": [
                                                    {
                                                      "isLeftCard": true
                                                    }
                                                  ]
                                                }
                                              }
                                            }
                                          },
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 6
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "ActiveUsersMetricCard",
                                            "height": 160,
                                          },
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 6
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "NewUsersMetricCard",
                                            "height": 160,
                                          },
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 6
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "PcuMetricCard",
                                            "height": 160,
                                          },
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "name": "CommonRow",
                                    "className": "",
                                    "type": "layout",
                                    "style": {},
                                    "props": {},
                                    "children": [
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 8
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "D1t1MultiMetricCard",
                                            "height": 280,
                                          },
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 8
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "MedianOnlineTimeMultiMetricCard",
                                            "height": 280,
                                          }
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 8
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "MedianSessionTimeMultiMetricCard",
                                            "height": 280,
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "unChecked": [
                              {
                                "name": "PlatformMetricsCo",
                                "className": "margin-t-20",
                                "type": "view",
                                "style": {},
                                "props": {
                                  "config": {
                                    "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                    "metricsList": [
                                      "gross_full_game_units",
                                      "gross_revenue"
                                    ]
                                  }
                                },
                                "children": [
                                  {
                                    "name": "CommonRow",
                                    "className": "",
                                    "type": "layout",
                                    "style": {},
                                    "props": {},
                                    "children": [
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 12
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "GrossFullGameUnitsPlatformCard",
                                            "height": 235,
                                          },
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 12
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "GrossRevenuePlatformCard",
                                            "height": 235,
                                          },
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "name": "KeyMetricsCo",
                                "className": "dbd-daily-card",
                                "type": "view",
                                "style": {},
                                "props": {
                                  "config": {
                                    "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                    "haveJump": true,
                                    "mainMetricsList": [
                                      "lifetime_full_game_gross_units",
                                      "lifetime_gross_revenue",
                                      "lifetime_refund_rate",
                                      "active_users",
                                      "new_users",
                                      "d1t1",
                                      "median_online_time",
                                      "median_session_time",
                                      "pcu"
                                    ],
                                    "metricsList": [
                                      "lifetime_full_game_gross_units",
                                      "lifetime_gross_revenue",
                                      "lifetime_refund_rate",
                                      "active_users",
                                      "new_users",
                                      "d1t1",
                                      "median_online_time",
                                      "aot_hour",
                                      "above_2hr_users",
                                      "median_session_time",
                                      "avg_session_time",
                                      "avg_session_cnt",
                                      "pcu",
                                      "pcu_active_users_rate",
                                      "acu",
                                      "d2t2",
                                      "d7t7"
                                    ]
                                  }
                                },
                                "children": [
                                  {
                                    "name": "CommonRow",
                                    "className": "",
                                    "type": "layout",
                                    "style": {},
                                    "props": {},
                                    "children": [
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 12
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "LifetimeFullGameGrossUnitsMetricCard",
                                            "height": 160,
                                          }
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 12
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "LifetimeGrossRevenueMetricCard",
                                            "height": 160,
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "name": "CommonRow",
                                    "className": "",
                                    "type": "layout",
                                    "style": {},
                                    "props": {},
                                    "children": [
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 6
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "LifetimeRefundRateMetricCard",
                                            "height": 160,
                                          }
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 6
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "ActiveUsersMetricCard",
                                            "height": 160,
                                          }
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 6
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "NewUsersMetricCard",
                                            "height": 160,
                                          }
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 6
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "PcuMetricCard",
                                            "height": 160,
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "name": "CommonRow",
                                    "className": "",
                                    "type": "layout",
                                    "style": {},
                                    "props": {},
                                    "children": [
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 8
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "D1t1MultiMetricCard",
                                            "height": 280,
                                          }
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 8
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "MedianOnlineTimeMultiMetricCard",
                                            "height": 280,
                                          }
                                        ]
                                      },
                                      {
                                        "name": "CommonCol",
                                        "className": "",
                                        "type": "layout",
                                        "style": {},
                                        "props": {
                                          "w": 8
                                        },
                                        "children": [
                                          {
                                            "name": "MetricComponent",
                                            "path": "overview/daily",
                                            "componentKey": "MedianSessionTimeMultiMetricCard",
                                            "height": 280,
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      }
                    }
                  },
                  "data": {
                    "cardTitleSwitchVal": "checked"
                  }
                },
                {
                  "name": "EventService",
                  "className": "",
                  "type": "view",
                  "style": {
                    "marginTop": "10px"
                  },
                  "props": {},
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "OverviewMetricsTrendCoLeft",
                              "height": 467,
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "OverviewMetricsTrendCoRight",
                              "height": 467
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "MetricComponent",
                  "path": "overview/daily",
                  "componentKey": "OverviewTableCo",
                },
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "breakdown",
      "tabName": "By Platform/Region/Country",
      "tabNameCN": "分平台/区域/国家",
      "isHaveNotification": true,
      "notificationPath": "/overview/daily",
      "path": "/overview/daily/breakdown",
      "tabIcon": "pie-chart-icon",
      "logConfig": {
        "pageId": "200103",
        "pageName": "overviewPcConsoleDailyBreakdown",
        "extInfo": "overviewPcConsoleDailyBreakdown",
        "pagePath": "/overview/daily/breakdown"
      },
      "filters": [
        {
          "name": "PcConsoleDailyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/daily",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {
                    "marginTop": "10px"
                  },
                  "props": {},
                  "children": [
                    {
                      "name": "MetricComponent",
                      "path": "overview/daily",
                      "componentKey": "UserCompositionCo",
                      "style": {
                        "display": "flex",
                        "width": "100%",
                      }
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "MetricComponent",
                      "path": "overview/daily",
                      "componentKey": "RankListTabCo",
                      "style": {
                        "display": "flex",
                        "width": "100%",
                      }
                    }
                  ]
                }
              ]

            }
          ]
        }
      ]
    }
  ],
  "operationList": [
    {
      "nameEn": "情报",
      "nameCn": "Intelligence",
      "url": "function(data) { const { unifiedid } = data; return '/intelligence/topCharts/pcGames/gamesDetails/' + unifiedid; }"
    },
    {
      "nameEn": "舆情",
      "nameCn": "Opinions",
      "url": "/opinion/Overview",
      "params": {
        "gameid": "unifiedid"
      },
      "permission": "hasOpinionPermissions"
    }
  ]
};